import React from "react";
import Filters from "byzantine/src/filters";
import type OrganizationUser from "byzantine/src/OrganizationUser";
import { LoadingShim, Table } from "@narmi/design_system";

import { useCurrentUser } from "../contexts/CurrentUserContext";
import OrganizationUserStatusChip from "./OrganizationUserStatusChip";

interface OrganizationUserRowProps {
  member: OrganizationUser;
  onRowClick?: (user: OrganizationUser) => void;
}

const OrganizationUserRow: React.FC<OrganizationUserRowProps> = ({
  member,
  onRowClick,
}) => {
  const { currentUser } = useCurrentUser();

  if (!currentUser) {
    return <LoadingShim {...({ loading: true } as any)} />;
  }

  const goToEditUser = () => {
    onRowClick?.(member);
  };

  return (
    <Table.Row onRowClick={() => goToEditUser()}>
      <Table.Cell>
        <div>
          <div className="fontSize--s">{member.fullName()}</div>
          <p className="fontSize--s fontColor--secondary">{member.user.email ?? ""}</p>
        </div>
      </Table.Cell>
      <Table.Cell>{member.role.getDisplayName()}</Table.Cell>
      <Table.Cell>
        <OrganizationUserStatusChip status={member.status} />
      </Table.Cell>
      <Table.Cell>
        {member.user.last_login
          ? Filters.shortMonthDayYear(member.user.last_login as any)
          : ""}
      </Table.Cell>
    </Table.Row>
  );
};

export default OrganizationUserRow;
